import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const Portal: FC<{ children: ReactNode }> = ({ children }) => {
  const node = document.getElementById('modals');

  return <>{createPortal(children, node || document.body)}</>;
};
